import textGenerateApi from './textGenerate'

function parseJsonContent(raw) {
  if (!raw || typeof raw !== 'string') return null
  let text = raw.trim()
  const codeBlockMatch = text.match(/^```(?:json)?\s*([\s\S]*?)```\s*$/)
  if (codeBlockMatch) text = codeBlockMatch[1].trim()
  try {
    return JSON.parse(text)
  } catch {
    return null
  }
}

function normalizeError(response, fallback = 'Generation failed.') {
  if (response?.data?.error && typeof response.data.error === 'string') {
    return response.data.error
  }
  return fallback
}

const generateStructuredText = async ({ prompt, systemPrompt, model = 'gpt-4o-mini' }) => {
  const response = await textGenerateApi.generateText({
    prompt,
    systemPrompt,
    responseFormat: 'json_object',
    model,
  })

  if (!response.ok || !response.data?.content) {
    return { ok: false, data: { error: normalizeError(response) } }
  }

  const parsed = parseJsonContent(response.data.content)
  if (!parsed || typeof parsed !== 'object') {
    return { ok: false, data: { error: 'Invalid response from generation service.' } }
  }

  return { ok: true, data: parsed }
}

export default { generateStructuredText, parseJsonContent, normalizeError }
